import React, {useCallback, useContext, useEffect, useReducer, useRef, useState} from 'react';
import {BaseStyle} from "../../../styles/shared/BaseStyle";
import {useHistory} from "react-router-dom";
import HideAppBar from "../../widgets/header/HideAppBar";
import Grid from "@mui/material/Grid";
import {
	Card,
	CardContent,
	CardHeader, Collapse,
	Container,
	FormControl,
	InputLabel,
	MenuItem,
	Paper, Select,
	TextField
} from "@mui/material";
import clsx from "clsx";
import useGetAllFocolai from "./utils/useGetAllFocolai";
import FocolaiDrawer from "./drawer/FocolaiDrawer";
import FocolaioCard from "./detail/FocolaioCard";
import { Alert, AlertTitle, Skeleton } from '@mui/material';
import InputAdornment from "@mui/material/InputAdornment";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import SearchTwoToneIcon from "@mui/icons-material/SearchTwoTone";
import {ContattaciStyle} from "../../../styles/pages/contact/ContattaciStyle";
import FilterListTwoToneIcon from "@mui/icons-material/FilterListTwoTone";
import {AUTOMATION_INITIAL_STATE, AutomationReducer, initAutomationState} from "../../../reducers/AutomationReducer";
import {onClickDetails} from "../../../services/AutomationServices";
import {clean, getAccountInfo} from "../../../utils/GenericUtils";
import {setOpenSnackbar} from "../../../services/AppServices";
import {AppContext} from "../../../App";
import CustomText from "../../widgets/inputs/CustomText";
import {useForm} from "react-hook-form";

const GestioneFocolai = () => {
	const classes = BaseStyle();
	const contattaciClasses = ContattaciStyle();
	const {getValues, control, errors} = useForm({
		mode: "onChange",
	});
	const history = useHistory();
	const [stato, setStato] = useState("ATTIVO");
	const [value, setValue] = useState("");
	const [open, setOpen] = useState(false);
	const [sort, setSort] = useState("dataUltimaModifica");
	const [dir, setDir] = useState("ASC");
	const [search, setSearch] = useState({})
	const [pageNumber, setPageNumber] = useState(0);
	const {loading, error, focolai, hasMore} = useGetAllFocolai(stato, pageNumber, search, sort, dir);
	const appContext = useContext(AppContext);
	const [automationState, automationDispatch] = useReducer(AutomationReducer, AUTOMATION_INITIAL_STATE, initAutomationState);
	const [selected, setSelected] = useState("")
	
	const observer = useRef();
	
	const setMenuSelected = useCallback((newValue) => {
		setPageNumber(0);
		setStato(newValue);
	}, []);
	
	const lastTicketElementRef = useCallback(node => {
		if (loading) return
		if (observer.current) observer.current.disconnect()
		observer.current = new IntersectionObserver(entries => {
			if (entries[0].isIntersecting && hasMore && value === "") {
				setPageNumber(prevState => prevState + 1);
			}
		})
		if (node) observer.current.observe(node)
	}, [loading, hasMore, value])
	
	const goToFocolaio = useCallback((focolaio) => {
		setSelected(focolaio)
		onClickDetails(focolaio.id, "focolaio", "modify", automationDispatch);
	}, [automationDispatch])
	
	useEffect(() => {
		if (!automationState.loadingOnClick && automationState.errorOnClick === "") {
			if (automationState.operatorOnClick.replace("ERR_", "").includes(getAccountInfo().alias)) {
				history.push("/gestione/focolai/" + selected.id + "/soggetto/" + selected.quarantene[0].soggetto.idSoggetto);
			} else {
				setOpenSnackbar("warning", ("L'ordinanza è al momento gestita da " + automationState.operatorOnClick?.replace("ERR_", "") + ". Ritenta e sari più fortunato :)"), appContext.dispatch)
			}
		}
	}, [automationState.loadingOnClick, automationState.errorOnClick, automationState.operatorOnClick, selected, history, appContext.dispatch])
	
	
	useEffect(() => {
		setPageNumber(0)
	}, [stato, value, sort, dir])
	
	useEffect(() => {
		document.body.style = `background-image: none`;
	}, []);
	
	return (
        <React.Fragment>
            <main className={classes.main}>
				<HideAppBar title={"Associazioni di Ordinanze"}/>
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Paper
								className={clsx(classes.roundBorder, classes.filterSearchPaper)}
								component={"section"}>
								<TextField
									placeholder={"Cerca per Codice fiscale"}
									value={value}
									onChange={(e) => setValue(e.target.value)}
									autoFocus={true}
									fullWidth={true}
									variant={"outlined"}
									InputProps={{
										startAdornment: <InputAdornment position="start">
											<Tooltip title={"Cerca"}>
												<IconButton
                                                    color="inherit"
                                                    onClick={() => {
                                                        if (value !== "") {
                                                            setSearch({
                                                                codF: value
                                                            })
                                                        } else {
                                                            setSearch(clean(getValues()?.search))
                                                        }
                                                    }}
                                                    size="large">
													<SearchTwoToneIcon/>
												</IconButton>
											</Tooltip>
										</InputAdornment>,
										endAdornment: <InputAdornment position="start">
											<Tooltip title={"Ricerca avanzata"}>
												<IconButton
                                                    color="inherit"
                                                    onClick={() => setOpen(!open)}
                                                    className={clsx(classes.expand, {
                                                        [classes.expandOpen]: open,
                                                    })}
                                                    size="large">
													<FilterListTwoToneIcon/>
												</IconButton>
											</Tooltip>
										</InputAdornment>,
										classes: {notchedOutline: contattaciClasses.noBorder},
									}}
								/>
								<Collapse in={open} timeout="auto" unmountOnExit>
									<Grid container spacing={3} className={classes.padding2}>
										<Grid item xs={12} sm={6}>
											<FormControl variant="outlined" fullWidth>
												<InputLabel id="sort">Ordina per</InputLabel>
												<Select
													labelId="sort"
													id="sort"
													value={sort}
													onChange={(e) => setSort(e.target.value)}
													label="Ordina per"
												>
													<MenuItem value={"dataUltimaModifica"}>Data ultima modifica</MenuItem>
													<MenuItem value={"lastModify"}>Operatore ultima modifica</MenuItem>
												</Select>
											</FormControl>
										</Grid>
										<Grid item xs={12} sm={6}>
											<FormControl variant="outlined" fullWidth>
												<InputLabel id="dir">Ascendente / Discendente</InputLabel>
												<Select
													labelId="dir"
													id="dir"
													value={dir}
													onChange={(e) => setDir(e.target.value)}
													label="Ascendente / Discendente"
												>
													<MenuItem value={"ASC"}>Dal più piccolo al più grande</MenuItem>
													<MenuItem value={"DESC"}>Dal più grande al più piccolo</MenuItem>
												</Select>
											</FormControl>
										</Grid>
										<Grid item xs={12} sm={6}>
											<CustomText
												control={control}
												rules={{required: false}}
												name={"search.codF"}
												label={"Codice fiscale"}
												autoFocus={false}
												error={errors["search"]?.["codF"]}
											/>
										</Grid>
										<Grid item xs={12} sm={6}>
											<CustomText
												control={control}
												rules={{required: false}}
												name={"search.cell"}
												label={"Cellulare"}
												autoFocus={false}
												type={"number"}
												error={errors["search"]?.["cell"]}
											/>
										</Grid>
										<Grid item xs={12} sm={4}>
											<CustomText
												control={control}
												rules={{required: false}}
												name={"search.nome"}
												label={"Nome"}
												autoFocus={false}
												error={errors["search"]?.["nome"]}
											/>
										</Grid>
										<Grid item xs={12} sm={4}>
											<CustomText
												control={control}
												rules={{required: false}}
												name={"search.cognome"}
												label={"Cognome"}
												autoFocus={false}
												error={errors["search"]?.["cognome"]}
											/>
										</Grid>
										<Grid item xs={12} sm={4}>
											<CustomText
												control={control}
												rules={{required: false}}
												name={"search.alias"}
												label={"Alias"}
												autoFocus={false}
												error={errors["search"]?.["alias"]}
											/>
										</Grid>
									</Grid>
								</Collapse>
							</Paper>
						</Grid>
						<Grid item xs={12}>
							<Card className={clsx(classes.roundBorder)}
							      style={{height: "100%", display: "flex", flexDirection: "column"}}>
								<CardContent style={{flexGrow: 1, display: "flex"}}>
									
									<FocolaiDrawer stato={stato} selectMenuItem={setMenuSelected}/>
									
									<div className={classes.content}
									     style={{maxHeight: "80vh", overflowY: "auto", overflowX: "hidden",}}>
										{
											focolai.map((focolaio, index) => {
												if (focolai.length === index + 1) {
													return (
														<Card ref={lastTicketElementRef} key={focolaio.id}
														      className={clsx(classes.roundBorder, classes.mailCard)}>
															<FocolaioCard focolaio={focolaio} goToFocolaio={goToFocolaio}/>
														</Card>
													)
												} else {
													return (
														<Card key={focolaio.id}
														      className={clsx(classes.roundBorder, classes.mailCard)}>
															<FocolaioCard focolaio={focolaio} goToFocolaio={goToFocolaio}/>
														</Card>
													)
													
												}
											})
										}
										
										{!loading && !error && focolai.length === 0 &&
											<Alert severity="info" style={{borderRadius: 24}}>
												<AlertTitle>Evvai 😇!!</AlertTitle>
												Non ci sono focolai! Goditi questo meritato relax
											</Alert>}
										{!loading && error &&
											<Alert severity="error" style={{borderRadius: 24}}>
												<AlertTitle>Errore</AlertTitle>
												Prova ad effettuare un refresh della pagina entro 5 minuti. Se l'errore persiste contatta gli
												sviluppatori.
											</Alert>}
										{loading &&
											<Card className={clsx(classes.roundBorder, classes.mailCard)} elevation={0}>
												<CardHeader
													avatar={<Skeleton variant="circular" height={40} width={40}/>}
													title={<Skeleton width={180}/>}
													subheader={<Skeleton width={260}/>}
													action={<Skeleton variant="circular" height={20} width={20}/>}
													style={{paddingBottom: 2}}
												/>
												<CardContent style={{paddingTop: 0, marginTop: -35}}>
													<Skeleton height={200}/>
												</CardContent>
											</Card>}
									</div>
								</CardContent>
							</Card>
						</Grid>
					</Grid>
				</Container>
			</main>
        </React.Fragment>
    );
};

export default React.memo(GestioneFocolai);
